import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'ecp-map-dot-popup',
    templateUrl: './map-dot-popup.component.html',
    styleUrls: ['./map-dot-popup.component.css']
})
export class MapDotPopupComponent implements OnInit {
    @Input() isCloseBtn = true;
    @Input() customPosition: object;
    @Output() ecpClose = new EventEmitter();
    @ViewChild('popup', { static: true }) elementView: ElementRef;

    popupHeight: number;
    popupWidth: number;

    close(){
        this.ecpClose.emit();
    }
    constructor() {
    }

    ngOnInit() {
        this.popupWidth = this.elementView.nativeElement.offsetWidth;
        this.popupHeight = this.elementView.nativeElement.offsetHeight;


        console.log(this.popupWidth, this.popupHeight);
    }

}
